import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function S() {
    const { useLang } = useGlobal();
    const { t } = useLang('costsaving');

    return (
        <div id="cost-saving-S" className={`cost-saving-S ${css['cost-saving-S']}`}>
            <div className="text-info">
                <p className="title">{t('secS_title')}</p>
                <p className="desc">{t('secS_desc')}</p>
            </div>
        </div>
    );
}
